const placeholderOption = { label: 'Selecione...', value: '' };

export const buildFormStructure = (modeloOptions = [], { loadingModelos = false } = {}) => [
  [
    {
      name: 'frota',
      label: 'Frota',
      component: 'FormField',
      type: 'text',
      placeholder: 'Ex.: 1234',
      colProps: { md: 6 },
      maxLength: 60,
      required: true,
    },
    {
      name: 'placa',
      label: 'Placa',
      component: 'FormField',
      type: 'text',
      placeholder: 'Ex.: ABC1D23',
      colProps: { md: 6 },
      maxLength: 10,
      required: true,
    },
  ],
  [
    {
      name: 'renavam',
      label: 'Renavam',
      component: 'FormField',
      type: 'text',
      placeholder: 'Ex.: 12345678901',
      colProps: { md: 6 },
      maxLength: 11,
      required: true,
    },
    {
      name: 'uf',
      label: 'UF',
      component: 'FormField',
      type: 'text',
      placeholder: 'Ex.: SP',
      colProps: { md: 6 },
      maxLength: 2,
      required: true,
    },
  ],
  [
    {
      name: 'idModeloVeicular',
      label: 'Modelo Veicular',
      component: 'SearchSelect',
      type: 'search',
      options: [placeholderOption, ...modeloOptions],
      colProps: { md: 12 },
      required: true,
      disabled: loadingModelos,
      minSearchLength: 0,
    },
  ],
];

export const buildFormSections = (initialValues = {}) => [
  {
    title: `Dados do Veiculo${initialValues.placa ? ` - ${initialValues.placa}` : ''}`,
    rows: [0, 1, 2],
  },
];

export const validateForm = (values = {}) => {
  const errors = {};
  const trim = (value) => (typeof value === 'string' ? value.trim() : '');

  const frota = trim(values.frota);
  if (!frota) {
    errors.frota = 'Informe a frota.';
  } else if (frota.length > 60) {
    errors.frota = 'Maximo de 60 caracteres.';
  }

  const placa = trim(values.placa).toUpperCase();
  if (!placa) {
    errors.placa = 'Informe a placa.';
  } else {
    const placaNormalizada = placa.replace(/[^A-Z0-9]/g, '');
    if (placaNormalizada.length < 7 || placaNormalizada.length > 8) {
      errors.placa = 'Placa invalida.';
    }
  }

  const renavam = trim(values.renavam);
  const renavamNumerico = renavam.replace(/\D+/g, '');
  if (!renavamNumerico) {
    errors.renavam = 'Informe o Renavam.';
  } else if (renavamNumerico.length !== 11) {
    errors.renavam = 'Renavam deve conter 11 digitos.';
  }

  const uf = trim(values.uf).toUpperCase();
  if (!uf) {
    errors.uf = 'Informe a UF.';
  } else if (!/^[A-Z]{2}$/.test(uf)) {
    errors.uf = 'UF invalida. Utilize duas letras.';
  }

  const modeloSelecionado = values.idModeloVeicular;
  const possuiModelo =
    modeloSelecionado &&
    ((typeof modeloSelecionado === 'object' && modeloSelecionado.value) ||
      (typeof modeloSelecionado === 'string' && modeloSelecionado.trim() !== '') ||
      typeof modeloSelecionado === 'number');

  if (!possuiModelo) {
    errors.idModeloVeicular = 'Selecione um modelo.';
  }

  return errors;
};
